import React, {useState, useEffect} from 'react';
import {Container} from 'reactstrap';
import {connect} from 'react-redux';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import {addDisconnectReason, goToPage, removeDisconnectReason, stepParams} from '../DisconnectServiceSlice';
import './ChooseReasonOfDisconnect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import Helper from '../../../../utilities/analytics/helper';

function ChooseReasonOfDisconnect(props) {
  const [choiceCounter, setChoiceCounter] = useState(0);
  const [ok, SetOk] = useState(false);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    if (props.Service == 'Cellular') {
      gaEvent(
        gaParams.DISCONNECT_ENTER_PAGE_DISCONNECT_REASONS_CELLULAR.category,
        gaParams.DISCONNECT_ENTER_PAGE_DISCONNECT_REASONS_CELLULAR.eventType,
        gaParams.DISCONNECT_ENTER_PAGE_DISCONNECT_REASONS_CELLULAR.eventParams
      );
    } else {
      gaEvent(
        gaParams.DISCONNECT_ENTER_PAGE_DISCONNECT_REASONS.category,
        gaParams.DISCONNECT_ENTER_PAGE_DISCONNECT_REASONS.eventType,
        props.Service
      );
    }
  }, []);

  useEffect(() => {
    choiceCounter > 0 || (props.disconnectReasons && props.disconnectReasons.length > 0) ? SetOk(true) : SetOk(false);
  }, [choiceCounter]);

  function onCheck(nameToDisconnect) {
    setChoiceCounter(choiceCounter + 1);
    props.addDisconnectReason(nameToDisconnect);
    reportGoogleAnalytics(nameToDisconnect);
  }

  function onUncheck(nameToRevert) {
    setChoiceCounter(choiceCounter - 1);
    props.removeDisconnectReason(nameToRevert);
  }

  function checkReasonExists(reason) {
    let boolean = props.disconnectReasons.includes(reason);
    return boolean;
  }

  function reportGoogleAnalytics(reason) {
    switch (props.Service) {
      case 'TV':
        gaEvent(
          gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.category,
          gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.eventType,
          Helper.objToString(
            {serviceType: props.Service, reason: reason},
            gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.eventParams
          )
        );
        break;
      case 'Cellular':
        break;
      case 'Internet':
        gaEvent(
          gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.category,
          gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.eventType,
          Helper.objToString(
            {serviceType: props.Service, reason: reason},
            gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.eventParams
          )
        );
        break;
      case 'Bundle':
        gaEvent(
          gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.category,
          gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.eventType,
          Helper.objToString(
            {serviceType: props.Service, reason: reason},
            gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT.eventParams
          )
        );
        break;
      default:
        break;
    }
  }

  function renderChoosingOptions(choice) {
    switch (choice) {
      case 'TV':
        return (
          <ul className='services-to-choose-container'>
            <li className='service'>
              <CheckBox
                id='1'
                onCheck={() => onCheck('בעקבות תקלות')}
                onUncheck={() => onUncheck('בעקבות תקלות')}
                checked={checkReasonExists('בעקבות תקלות')}
                label={'בעקבות תקלות'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='2'
                onCheck={() => onCheck('התכנים לא תאמו את הציפיות שלי')}
                onUncheck={() => onUncheck('התכנים לא תאמו את הציפיות שלי')}
                checked={checkReasonExists('התכנים לא תאמו את הציפיות שלי')}
                label={'התכנים לא תאמו את הציפיות שלי'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='3'
                onCheck={() => onCheck('השירות שקיבלתי לא היה טוב')}
                onUncheck={() => onUncheck('השירות שקיבלתי לא היה טוב')}
                checked={checkReasonExists('השירות שקיבלתי לא היה טוב')}
                label={'השירות שקיבלתי לא היה טוב'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='4'
                onCheck={() => onCheck('המחיר יקר מדי')}
                onUncheck={() => onUncheck('המחיר יקר מדי')}
                checked={checkReasonExists('המחיר יקר מדי')}
                label={'המחיר יקר מדי'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='5'
                onCheck={() => onCheck(`אין לי צורך ב${window.Config.brand_Name_HE} TV`)}
                onUncheck={() => onUncheck(`אין לי צורך ב${window.Config.brand_Name_HE} TV`)}
                checked={checkReasonExists(`אין לי צורך ב${window.Config.brand_Name_HE} TV`)}
                label={`אין לי צורך ב${window.Config.brand_Name_HE} TV`}></CheckBox>
            </li>
          </ul>
        );
      case 'Cellular':
        return (
          <ul className='services-to-choose-container'>
            <li className='service'>
              <CheckBox
                id='1'
                onCheck={() => onCheck('בעקבות תקלות גלישה/קליטה')}
                onUncheck={() => onUncheck('בעקבות תקלות גלישה/קליטה')}
                checked={checkReasonExists('בעקבות תקלות גלישה/קליטה')}
                label={'בעקבות תקלות גלישה/קליטה'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='2'
                onCheck={() => onCheck('המחיר יקר מדי')}
                onUncheck={() => onUncheck('המחיר יקר מדי')}
                checked={checkReasonExists('המחיר יקר מדי')}
                label={'המחיר יקר מדי'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='3'
                onCheck={() => onCheck('השירות שקיבלתי לא היה טוב')}
                onUncheck={() => onUncheck('השירות שקיבלתי לא היה טוב')}
                checked={checkReasonExists('השירות שקיבלתי לא היה טוב')}
                label={'השירות שקיבלתי לא היה טוב'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='4'
                onCheck={() => onCheck('אין לי צורך בקו')}
                onUncheck={() => onUncheck('אין לי צורך בקו')}
                checked={checkReasonExists('אין לי צורך בקו')}
                label={'אין לי צורך בקו'}></CheckBox>
            </li>
          </ul>
        );
      case 'Internet':
        return (
          <ul className='services-to-choose-container'>
            <li className='service'>
              <CheckBox
                id='1'
                onCheck={() => onCheck('תקלות')}
                onUncheck={() => onUncheck('תקלות')}
                checked={checkReasonExists('תקלות')}
                label={'תקלות'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='2'
                onCheck={() => onCheck('לא מקבל את המהירות שהובטחה לי')}
                onUncheck={() => onUncheck('לא מקבל את המהירות שהובטחה לי')}
                checked={checkReasonExists('לא מקבל את המהירות שהובטחה לי')}
                label={'לא מקבל את המהירות שהובטחה לי'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='3'
                onCheck={() => onCheck('המחיר יקר לי מדי')}
                onUncheck={() => onUncheck('המחיר יקר לי מדי')}
                checked={checkReasonExists('המחיר יקר לי מדי')}
                label={'המחיר יקר לי מדי'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='4'
                onCheck={() => onCheck('השירות שקיבלתי לא היה טוב')}
                onUncheck={() => onUncheck('השירות שקיבלתי לא היה טוב')}
                checked={checkReasonExists('השירות שקיבלתי לא היה טוב')}
                label={'השירות שקיבלתי לא היה טוב'}></CheckBox>
            </li>
          </ul>
        );
      case 'Bundle':
        return (
          <ul className='services-to-choose-container'>
            <li className='service'>
              <CheckBox
                id='1'
                onCheck={() => onCheck('תקלות')}
                onUncheck={() => onUncheck('תקלות')}
                checked={checkReasonExists('תקלות')}
                label={'תקלות'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='2'
                onCheck={() => onCheck('לא מקבל את המהירות שהובטחה לי')}
                onUncheck={() => onUncheck('לא מקבל את המהירות שהובטחה לי')}
                checked={checkReasonExists('לא מקבל את המהירות שהובטחה לי')}
                label={'לא מקבל את המהירות שהובטחה לי'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='3'
                onCheck={() => onCheck('המחיר יקר לי מדי')}
                onUncheck={() => onUncheck('המחיר יקר לי מדי')}
                checked={checkReasonExists('המחיר יקר לי מדי')}
                label={'המחיר יקר לי מדי'}></CheckBox>
              <div className='line'></div>
            </li>
            <li className='service'>
              <CheckBox
                id='4'
                onCheck={() => onCheck('שירות לא טוב')}
                onUncheck={() => onUncheck('שירות לא טוב')}
                checked={checkReasonExists('שירות לא טוב')}
                label={'שירות לא טוב'}></CheckBox>
            </li>
          </ul>
        );
    }
  }

  function redirectAndReportGA() {
    gaEvent(
      gaParams.DISCONNECT_CLICK_ON_CONTINUE_DISCONNECT_REASONS.category,
      gaParams.DISCONNECT_CLICK_ON_CONTINUE_DISCONNECT_REASONS.eventType,
      Helper.objToString(
        {serviceType: props.Service, reasonsCount: props.disconnectReasons.length},
        gaParams.DISCONNECT_CLICK_ON_CONTINUE_DISCONNECT_REASONS.eventParams
      )
    );
    if (props.Service == 'Cellular') {
      gaEvent(
        gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT_CELLULAR.category,
        gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT_CELLULAR.eventType,
        Helper.objToString(
          {reason: props.disconnectReasons.join(', '), reasonsCount: props.disconnectReasons.length},
          gaParams.DISCONNECT_CLICK_AND_CHOOSE_REASONS_TO_DISCONNECT_CELLULAR.eventParams
        )
      );
    }
    props.goToPage({page: 'CONFIRM_DISCONNECT_PAGE', params: {...stepParams, hideHeader: false}});
  }

  return (
    <Container className='ChooseReasonOfDisconnect-root'>
      <div className='ChooseReasonOfDisconnect-block'>
        <h2 className='headers-root'>אוקיי, מכבדים</h2>
        <h5 className='headers'>כדי שנוכל להשתפר, נשמח לדעת מה הסיבות לניתוק (אפשר לבחור כמה)</h5>
        {renderChoosingOptions(props.Service)}
      </div>
      <div className={`btn-container${ok ? ' Ok' : ''}`}>
        <BtnSubmit text='המשך' onclick={() => redirectAndReportGA()} />
      </div>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  stepParams: state.disconnectServicesBlock.stepParams,
  Service: state.disconnectServicesBlock.serviceToDisconnect.serviceType,
  disconnectReasons: state.disconnectServicesBlock.summarizeUserDisconnectDetails.disconnectReasons,
});

const mapDispatchToProps = {
  goToPage,
  addDisconnectReason,
  removeDisconnectReason,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseReasonOfDisconnect);
